<template>
  <div
    :class="
      classes(
        n(),
        n(`--${size}`),
        n(`--${variant}`),
        n(`--${color}`)
      )
    "
    :style="style"
  >
    <div :class="n('content')">
      <i
        v-if="icon"
        :class="n('icon')"
      >
        <component :is="icon" />
      </i>
      <span>{{ content }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { props, BUILT_IN_COLOR_MAP } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { fade, darken } from '../utils/color';

const { name, n, classes } = createNamespace('tag');

export default defineComponent({
  name,
  props,
  emits,
  setup(props) {
    // LiteApp 不支持用 CSS 变量控制颜色，这里将内置色与自定义色统一解析为具体色值内联下发
    const style = computed(() => {
      const baseColor = BUILT_IN_COLOR_MAP[props.color] || props.color;
      if (props.variant === 'light-outline') {
        return {
          backgroundColor: fade(baseColor, 10),
          // light-outline 文字色需叠加 10% 黑色
          color: darken(baseColor, 0.1),
          borderColor: fade(baseColor, 20),
        };
      }
      return {
        backgroundColor: baseColor,
        color: '#FFFFFF',
        borderColor: baseColor,
      };
    });
    return {
      n,
      classes,
      style,
    };
  },
});
</script>
